import { format } from 'date-fns/esm';
import React, { Component, Fragment } from 'react';
import { FaPlusCircle } from 'react-icons/fa';
import { connect } from 'react-redux';

import {
  firebaseConnect,
  firestoreConnect,
  isLoaded,
} from 'react-redux-firebase';
import { compose } from 'recompose';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Row,
} from 'shards-react';
import LoadingComponent from '../../common/loading/LoadingComponent';
import { closeModal, openModal } from '../../common/modals/modalActions';
import { objectToArray } from '../../common/util/helper';
import { deleteAgent } from '../../pages/Agents/agentActions';
import { agentQuery } from './agentQuery';
const mapState = (state) => {
  const profile = state.firebase.profile;
  const agents = objectToArray(state.firestore.data.agents) || [];
  const agentGraphData =
    objectToArray(state.firebase.data.agentGraphData) || [];
  const auth = state.firebase.auth;

  return { agents, profile, auth, agentGraphData };
};
const actions = {
  openModal,
  closeModal,
  deleteAgent,
};

class AgentsDashboard extends Component {
  componentDidMount() {
    // setTimeout(() => {
    //   const { agents, agentGraph } = this.props;
    //   let queryArray = ['processing', 'closed', 'overdue'];
    //   let currentYear = new Date().getFullYear();
    //   // let graphData = [];
    //   // graphData = objectToArray(agentGraph[currentYear]);
    //   if (agents.length > 0 && agentGraph.length > 0) {
    //     console.log('trigger');
    //     agents.map((agent) => {
    //       if (agentGraph[agent.uid]) {
    //         return (agent.stats = agentGraph[agent.uid]);
    //       }
    //     });
    //     //
    //     console.log(agents);
    //   }
    // }, 2000);
  }

  addNewModal = () => {
    //console.log('trigger');
    this.props.openModal('AddNewAgent');
  };
  render() {
    const currentMonth = new Date().getMonth();
    const {
      agents,
      closeModal,
      openModal,
      deleteAgent,
      agentGraphData,
    } = this.props;
    if (!isLoaded(agents) && agents !== null)
      return <LoadingComponent loading={true} />;
    return (
      <Container fluid className='h-100 my-3'>
        <Fragment>
          {agents && agents.length > 0 ? (
            <Fragment>
              <Card small className='mb-4'>
                <CardHeader className='border-bottom d-flex justify-content-between bg-primary1'>
                  <h5 className='m-0'>Agents</h5>
                  <Button
                    onClick={() => this.addNewModal()}
                    className='align-content-center'
                  >
                    <FaPlusCircle className='mr-2' />
                    <span>Add</span>
                  </Button>
                </CardHeader>
                <CardBody className='p-0 pb-3'>
                  <table className='table mb-0'>
                    <thead className='bg-light'>
                      <tr>
                        <th scope='col' className='border-0 col-auto'>
                          Name
                        </th>
                        <th scope='col' className='border-0 col-auto'>
                          Role
                        </th>
                        <th scope='col' className='border-0 col-auto'>
                          Email
                        </th>
                        <th scope='col' className='border-0 col-auto'>
                          Last Login
                        </th>
                        <th scope='col' className='border-0 text-center'>
                          Tickets
                        </th>
                        <th scope='col' className='border-0 text-center'>
                          Details
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {agents &&
                        agents.map((agent) => (
                          <tr key={agent.uid}>
                            <td className='col-auto text-break '>
                              {agent.displayName}
                            </td>
                            <td className='col-auto text-break '>
                              {agent.role}
                            </td>
                            <td className='col-auto text-break '>
                              {agent.email}
                            </td>

                            <td>
                              {agent.lastSignIn &&
                                format(
                                  agent.lastSignIn.toDate(),
                                  'dd MMM yyy hh:mm'
                                )}
                            </td>
                            <td className='mx-auto text-center'>
                              {agent &&
                              agentGraphData?.length > 0 &&
                              agentGraphData[agent.uid] ? (
                                <Fragment>
                                  <Row className='justify-content-center'>
                                    <Col
                                      sm='12'
                                      lg='auto'
                                      className='pill ticket-processing mb-1 text-left mr-2'
                                    >
                                      <span className='ml-2 float-right'>
                                        {
                                          agentGraphData[agent.uid]?.overall
                                            ?.processing
                                        }
                                      </span>
                                    </Col>
                                    <Col
                                      sm='12'
                                      lg='auto'
                                      className='pill ticket-closed mb-1 text-left mr-2'
                                    >
                                      Closed:
                                      <span className='ml-2 float-right'>
                                        {
                                          agentGraphData[agent.uid]?.overall
                                            .closed
                                        }
                                      </span>
                                    </Col>
                                    <Col
                                      sm='12'
                                      lg='auto'
                                      className='pill ticket-overdue mb-1 text-left mr-2'
                                    >
                                      Overdue:
                                      <span className='ml-2 float-right'>
                                        {
                                          agentGraphData[agent.uid]?.overall
                                            ?.overdue
                                        }
                                      </span>
                                    </Col>
                                  </Row>
                                </Fragment>
                              ) : (
                                ''
                              )}
                            </td>
                            <td className='text-center'>
                              <Button
                                outline
                                onClick={() =>
                                  openModal('AgentDetails', {
                                    agent,
                                    closeModal,
                                    deleteAgent,
                                  })
                                }
                              >
                                Details
                              </Button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </Fragment>
          ) : (
            <Fragment>
              No Agents assigned yet.
              <Button
                onClick={() => this.addNewModal()}
                className='align-content-center'
              >
                <FaPlusCircle className='mr-2' />
                <span>Add</span>
              </Button>
            </Fragment>
          )}
        </Fragment>
      </Container>
    );
  }
}

export default compose(
  connect(mapState, actions),
  firestoreConnect((auth, profile) => agentQuery(auth, profile)),
  firebaseConnect([
    {
      path: `/agents`,
      storeAs: 'agentGraphData',
    },
  ])
)(AgentsDashboard);
